import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import { IntlProvider } from 'react-intl'
import English from './languages/en.json'
import Spanish from './languages/es.json'
import French from './languages/fr.json'
import useStore from './store'

const messages = {
  en: English,
  es: Spanish,
  fr: French
}

const Root = () => {
  const { language, setLanguage } = useStore()
  const translations = messages[language] || messages['en']

  const handleLocaleChange = (newLocale) => {
    newLocale = newLocale in messages ? newLocale : 'en'
    setLanguage(newLocale)
  }

  return (
    <IntlProvider locale={language} messages={translations}>
      <App locale={language} setLocale={handleLocaleChange} />
    </IntlProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Root />)
